import { render, staticRenderFns } from "./convenios-select.vue?vue&type=template&id=315c5aa4&scoped=true"
import script from "./convenios-select.vue?vue&type=script&lang=js"
export * from "./convenios-select.vue?vue&type=script&lang=js"
import style0 from "./convenios-select.vue?vue&type=style&index=0&id=315c5aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315c5aa4",
  null
  
)

export default component.exports